import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";

import { useDispatch, useSelector } from 'react-redux';
import { resetUser } from '../../redux/slice/user';
import { persistor } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { axiosInstance as axios, endpoint } from "../../api/axios";


import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import BottomNavigationBar from "../../components/navbar/BottomNavigationBar";
import NotificationDialog from "../../components/home/dialog/NotificationDialog";
import UpdateProfileDialog from "./dialog/UpdateProfileDialog";

const ProfileList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();
  const currentUserId = useSelector(state => state.user.currentUserId);
  const user = useSelector(state => state.user.users[state.user.currentUserId]);
    const dispatch = useDispatch();

  const [dataUser,setDataUser] = useState({
    id: "",
    staff_id: "",
    name: "",
    email: "",
    mobile: "",
    address: "",
    address_by_idcard: "",
    status: "",
    employee_image: "",
    branch_id: "",
    branch_name: "",
    join_date: "",
    born_date: "",
    gender: "",
    });

    const getData = async () => {
      try {
        const response = await axios.get(endpoint.Profile.DetailUser, {
          headers: {
            Authorization: `${user.token_type} ${user.token}`,
          },
        });
  
        const userData = response.data?.data;
  
        setDataUser({
          id: userData?.id,
          staff_id: userData?.staff_id,
          name: userData?.name,
          email: userData?.email,
          mobile: userData?.mobile,
          address: userData?.address,
          address_by_idcard: userData?.address_by_idcard,
          status: userData?.status,
          employee_image: userData?.employee_image,
          branch_id: userData?.branch_id,
          branch_name: userData?.branch_name,
          join_date: userData?.join_date,
          born_date: userData?.born_date,
          gender: userData?.gender,
        });
  
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
  

    useEffect(() => {
      
      getData();
    }, []);
    

    

    const handleToLogout = async  () => {
        try{

          if (user?.token) {
          await axios.post(endpoint.auth.logout,{},
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            });

          }

          dispatch(resetUser({ id: currentUserId }));
          persistor.purge();    
          navigate('/');

        }catch(eror){
          console.error('Logout API error:', eror.status);
        }
        
      };

  const [openNotif, setOpenNotif] = useState(false);

  const [openUpdateProfile, setOpenUpdateProfile] = useState(false);

  const handleOpenNotif = () => {
    setOpenNotif(true);
  };
  const handleCloseNotif = () => {
    setOpenNotif(false);
  };

  const handleOpenUpdateProfile = () => {
    setOpenUpdateProfile(true);
  };
  const handleCloseUpdateProfile = () => {
    setOpenUpdateProfile(false);
    getData();
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -10,
            right: 20,
            width: 30,
            height: 30,
            backgroundColor: "success.light",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          onClick={handleOpenNotif}
        >
          <NotificationsRoundedIcon sx={{ color: "white", fontSize: 20 }} />
        </Box>

        <Typography
          variant={isMobile ? "p" : "h6"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Arial", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          Dr Gadget Indonesia
        </Typography>

        <Typography
          variant={isMobile ? "h5" : "p"}
          sx={{
            color: "white",
            alignItems: "left",
            fontWeight: "bold",
            justifyContent: "left",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          Teknisi
        </Typography>
      </Box>

      <Box
        sx={{
          minHeight: "7vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 2 : 4,
        }}
      ></Box>

      <Box sx={{ mt: -2 }}>
        <Paper
          elevation={3}
          sx={{ p: 2, backgroundColor: "rgba(255, 255, 255, 0.9)" }}
        >
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                gutterBottom
              >
                General
              </Typography>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                  cursor: "pointer",
                }}
                onClick={handleOpenUpdateProfile}
              >
                <Box display="flex" flexDirection="column" gap={4}>
                  <Box display="flex" alignItems="center" gap={3}>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        bgcolor: "primary.light",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PersonRoundedIcon
                        sx={{ color: "white", fontSize: 20 }}
                      />
                    </Box>
                    <Box>
                      <Typography
                        variant="p"
                        fontWeight="bold"
                        color="text.secondary"
                      >
                        Pengaturan Akun
                      </Typography>
                    </Box>

                    <Box>
                      <IconButton edge="end">
                        <ArrowForwardIosIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              </Paper>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                gutterBottom
              >
                Logout
              </Typography>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                  cursor: "pointer",
                }}
              >
                <Box display="flex" flexDirection="column" gap={4}>
                  <Box display="flex" alignItems="center" gap={2}
                  onClick={handleToLogout}>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        bgcolor: "success.light",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LogoutRoundedIcon sx={{ color: "white", fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography
                        variant="p"
                        fontWeight="bold"
                        color="text.secondary"
                      >
                        Sign Out
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <UpdateProfileDialog data={dataUser} onReload={getData} openUpdateProfile={openUpdateProfile} handleCloseUpdateProfile={handleCloseUpdateProfile} />
      <NotificationDialog
        open={openNotif}
        handleClose={handleCloseNotif}
      />


      <BottomNavigationBar />
    </>
  );
};

export default ProfileList;
